import type { DiffViewerProps } from "./diff-viewer.type";

import { highlight, languages } from "prismjs";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";

import "prismjs/themes/prism.css";

export const DiffViewer = ({ oldValue, newValue }: DiffViewerProps) => {
  const highlightSyntax = (line: string) => (
    <pre
      style={{ display: "inline" }}
      dangerouslySetInnerHTML={{
        __html: highlight(line, languages.javascript, "json"),
      }}
    />
  );

  return (
    <ReactDiffViewer
      oldValue={oldValue}
      newValue={newValue}
      compareMethod={DiffMethod.JSON}
      splitView={false}
      showDiffOnly={false}
      hideLineNumbers
      hideSummary
      renderContent={highlightSyntax}
      styles={{
        diffContainer: { minWidth: 0, fontSize: "14px" },
        contentText: { lineHeight: "25px" },
      }}
    />
  );
};
